import React, { Component, Fragment } from 'react'
import { A, ToolTip, Button, Div, H2, P } from '@driftt/tide-core';
import { Table } from '@driftt/tide-table'
import moment from 'moment'
import numeral from 'numeral'
import classnames from 'classnames'

import { CHART_NO_DATA_TEXT, dollarColumns } from 'constants/ReportConstants'
import { getIntegrations } from 'api/playbooks'
import GraphContainer from 'components/Reports/EmailPerformance/Graphs'
import RowFormatter from 'components/Reports/EmailPerformance/TableRowFormatter'
import { EmptyGraphAndPage } from 'components/Reports/EmailPerformance/EmptyState'
import ConnectSvg from './connect.svg'
import { hasGates } from 'utils/access'


class TotalDollarsInfluenced extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentData: null,
      dollarData: null,
      activeSection: 'CLOSED_WON',
      integrations: null
    }
  }
  getClassNames(activeSection) {
    const defaultClass = 'reports-data-callout-item'
    return {
      opportunities: classnames(defaultClass, {
        'reports-data-callout-item--highlighted': activeSection === 'OPPORTUNITIES'
      }),
      pipeline: classnames(defaultClass, {
        'reports-data-callout-item--highlighted': activeSection === 'PIPELINE'
      }),
      closedWon: classnames(defaultClass, {
        'reports-data-callout-item--highlighted': activeSection === 'CLOSED_WON'
      })
    }
  }

  getSalesforceIntegrationStatus = async () => {
    try {
      const { data } = await getIntegrations()
      this.setState({
        integrations: data
      })
    } catch (e) {
      console.log(e)
    }
  }

  componentDidMount() {
    this.getSalesforceIntegrationStatus()
  }

  generateTableRow = (email, index) => {
    const { totalSFRevenue } = this.props

    const emailCampaignReport =  totalSFRevenue.byEmail.find((mail) => mail.campaignId === email.campaignId)

    return RowFormatter.DollarRows(emailCampaignReport, email.title, index)
  }

  changeGraphData(section) {
    this.setState({
      activeSection: section,
      dollarData: this.generateGraphData(section)
    })
  }

  generateGraphData(section) {
    const { totalSFRevenue } = this.props
    const { activeSection } = this.state
    const subField = section || activeSection
    const currentGraphData = [], previousGraphData = []

    const rawPrevious = totalSFRevenue.byDate.previous
    const rawCurrent = totalSFRevenue.byDate.current

    rawCurrent.forEach((date, i) => {
      currentGraphData.push([moment.utc(date.date).valueOf(), date.metrics[subField].value])
    })

    rawPrevious.forEach((date, i) => {
      previousGraphData.push([currentGraphData[i][0], date.metrics[subField].value])
    })

    return {
      current: currentGraphData,
      previous: previousGraphData
    }
  }

  dismissUpsell(e) {
    e.preventDefault()

    window.localStorage.setItem('hideEmailSFNumbers', true)
  }

  renderTableAndGraph() {
    const { activeSection } = this.state
    const { activeState, playbook, totalSFRevenue, sfError } = this.props
    const {opportunities, pipeline, closedWon} = this.getClassNames(activeSection)

    const { actions } = playbook
    const { action } = actions[0]

    const emailCampaigns = action.emails ? action.emails : [{...action}]

    const totals = totalSFRevenue ? totalSFRevenue.total :
      {
        PIPELINE: {
          value: 0
        },
        OPPORTUNITIES: {
          value: 0
        },
        CLOSED_WON: {
          value: 0
        }
      }

    const hasData = totals.PIPELINE.value !== 0 && totals.OPPORTUNITIES.value !== 0 && totals.CLOSED_WON.value !== 0

    return (
      <Fragment>
        {hasData ?
          <Div className="reports-data-callout">
            <ToolTip component={
                <Div className="metric-tooltip-center">
                  Total number of opportinities<br />created from this playbook.
                </Div>
              } flow="up">
              <Div className={opportunities} onClick={() => this.changeGraphData('OPPORTUNITIES')}>
                <Div className="callout-header">Opportunities</Div>
                <Div className="callout-large">{totals.OPPORTUNITIES.value}</Div>
                <Div className="callout-subtext"></Div>
              </Div>
            </ToolTip>
            <ToolTip component={
                <Div className="metric-tooltip-center">
                  Total amount of pipeline<br />created from this playbook.
                </Div>
              } flow="up">
              <Div className={pipeline} onClick={() => this.changeGraphData('PIPELINE')}>
                <Div className="callout-header">Pipeline</Div>
                <Div className="callout-large">{numeral(totals.PIPELINE.value).format('($0a)')}</Div>
                <Div className="callout-subtext"></Div>
              </Div>
            </ToolTip>
            <ToolTip component={
                <Div className="metric-tooltip-center">
                  Total $ closed through this<br />playbook.
                </Div>
              } flow="up">
              <Div className={closedWon} onClick={() => this.changeGraphData('CLOSED_WON')}>
                <Div className="callout-header">Closed won</Div>
                <Div className="callout-large">{numeral(totals.CLOSED_WON.value).format('($0a)')}</Div>
                <Div className="callout-subtext"></Div>
              </Div>
            </ToolTip>
          </Div> :
          <Fragment>
            <Div className="reports-graph-data-overlay">
              <EmptyGraphAndPage />
              <H2>{ sfError ?
                <Div className="sf-error-message">We encountered an error retrieving data from Salesforce<br/>Talk to our CSMs to get your Salesforce account set up with Drift</Div> :
                CHART_NO_DATA_TEXT }
              </H2>
            </Div>
          </Fragment>
        }
        <Div className="reports-graph-container">
          {!!hasData &&
            <GraphContainer activeTab={activeState} graphData={this.generateGraphData()} />
          }
        </Div>
        <Div className="reports-table-container">
          <Table
            columns={dollarColumns}
            className="email-reports-table"
            data={!!totalSFRevenue ? emailCampaigns.map(this.generateTableRow) : []}
          />
        </Div>
      </Fragment>
    )
  }

  renderUpsell() {
    const { integrations } = this.state
    const { salesForceRevenueActive } = this.props

    const hasSalesforce = (integrations) ? integrations.salesforce : false

    const connectedButNotOptedIn = hasSalesforce && !salesForceRevenueActive
    const needsSalesforce = !hasSalesforce

    return (
      <Div className="upsell-salesforce-connection">
        <img src={ConnectSvg} alt="Connect your account!" />
        <Div className="upsell-salesforce-connection-text">
          <H2>How much impact is this playbook having?</H2>
          {!hasGates('premium_team') ?
            <Fragment>
              <P>Upgrade your Drift account to connect to Salesforce and enable review reporting.</P>
              <Div className="upsell-salesforce-buttons">
                <Button href="/settings/billing" type="primary" width="50%">Upgrade Drift</Button>
                <Button href="https://help.drift.com/article/marketing-email-reporting/" type="secondary" width="50%">Learn More</Button>
              </Div>
            </Fragment>
          :
          <Fragment>
            {connectedButNotOptedIn &&
              <Fragment>
                <P>Your Salesforce account is already connected!</P>
                <P>Enable Revenue Reporting to see how Drift influences Opportunities, Pipeline and Closed Won.</P>
                <Div className="upsell-salesforce-buttons">
                  <Button href="/settings2/integrations/detail/salesforce" type="primary" width="50%">Enable $$$ Reporting</Button>
                  <Button href="https://help.drift.com/article/marketing-email-reporting/" type="secondary" width="50%">Learn More</Button>
                </Div>
              </Fragment>
            }
            {needsSalesforce &&
              <Fragment>
                <P>Connect your Salesforce account to see how Drift influences Opportunities, Pipeline and Closed Won.</P>
                <Div className="upsell-salesforce-buttons">
                  <Button href="/settings2/integrations/detail/salesforce" type="primary" width="50%">Connect Salesforce</Button>
                  <Button href="https://help.drift.com/article/marketing-email-reporting/" type="secondary" width="50%">Learn More</Button>
                </Div>
              </Fragment>
            }
          </Fragment>
        }
          <A className="upsell-salesforce-dismiss" onClick={() => this.dismissUpsell}>Don&rsquo;t ask me about connecting Salesforce again</A>
        </Div>
      </Div>
    )
  }

  render() {
    const { salesForceRevenueActive } = this.props

    return (
      <Div className="email-performance-breakdown email-performance-breakdown--dollars">
        {salesForceRevenueActive ? this.renderTableAndGraph() : this.renderUpsell()}
      </Div>
    )
  }
}

export default TotalDollarsInfluenced
